import React from "react";
import { formatCurrency } from "../../lib/utils";

export function PriceDisplay({ amount, className = "" }) {
  return <span className={`font-medium ${className}`}>{formatCurrency(amount)}</span>;
}
